import QuotationError from './QuotationError';
class QuotationPropertyNotFound extends QuotationError {
    propertyId;
    constructor(propertyId, options) {
        super('The crowdfunding property does not exist', options);
        this.propertyId = propertyId;
    }
}
export default QuotationPropertyNotFound;
